




















import Component from 'vue-class-component'
import {IModalComponentProps} from './IModalComponent'
import {faTimesCircle, IconDefinition} from '@fortawesome/free-regular-svg-icons'

@Component({
    watch: {
        'show': 'handleShowStatusChange'
    }
})
export default class ModalComponent extends IModalComponentProps {
    private componentClass = "ModalComponent"
    private modalCloseIcon: IconDefinition = faTimesCircle
    private showModal = false

    get getClassModificator(): string {
        return this.classModificator ? `${this.componentClass}__${this.classModificator}` : ''
    }

    get getSubTitle(): string {
        return this.subtitle ? `: ${this.subtitle}` : ''
    }

    get showWithSubtitle(): boolean {
        return this.subtitle && this.subtitle.length > 0
    }

    handleShowStatusChange() {
        this.showModal = !this.showModal
    }

    onOkListener(BvModalEvent) {
        BvModalEvent.preventDefault()
        this.onOk()
    }
}
